/* eslint-disable max-len */

import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const SuccessTickSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
    <svg  class="${
      props.svgStyles ?? ''
    }" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 29.091 29.315">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_542" data-name="Rectangle 542" width="100%" height="100%" transform="translate(0 0)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </clipPath>
      </defs>
      <g id="Group_2641" data-name="Group 2641" transform="translate(0 0)" clip-path="url(#clip-path)">
        <g id="Ellipse_79" data-name="Ellipse 79" transform="translate(0.416 0.64)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2">
          <circle cx="14.129" cy="14.129" r="14.129" stroke="none"/>
          <circle cx="14.129" cy="14.129" r="13.129" fill="none"/>
        </g>
        <path id="Path_1686" data-name="Path 1686" d="M33.055,26.652,24.6,35.107l-5.518-5.518" transform="translate(-11.439 -15.977)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
      </g>
    </svg>
  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default SuccessTickSvg
